module.exports = __webpack_public_path__ + "img/4-02.b98cb8db.png";